var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dense":"","color":_vm.color}},_vm._l((_vm.data),function(val,i){return _c('v-list-item',{key:i,staticClass:"litem"},[_c('h3',[_vm._v(" "+_vm._s(val.descricao)+" | "+_vm._s(Number(val.total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }))+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }